import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import workspacesService from '../services/workspaces.service'

export const useWorkspaceStore = create(
  persist(
    (set, get) => ({
  workspaces: [{ id: 'default', name: 'Personal', icon: '🏠' }],
  activeWorkspaceId: 'default',
  isLoading: false,

  fetchWorkspaces: async () => {
    set({ isLoading: true })
    try {
      const data = await workspacesService.getWorkspaces()
      if (data.length > 0) {
        set({ workspaces: data, activeWorkspaceId: data[0].id })
      }
    } catch (e) { 
      console.error(e) 
    }
    set({ isLoading: false })
  },
  
  addWorkspace: async (workspace) => {
    try {
      const newW = await workspacesService.createWorkspace(workspace)
      set((state) => ({ workspaces: [...state.workspaces, newW], activeWorkspaceId: newW.id }))
      return newW
    } catch (e) { 
      console.error(e) 
    }
  },
  
  setActiveWorkspace: (id) => set({ activeWorkspaceId: id }),
  
  removeWorkspace: async (id) => {
    try {
      await workspacesService.deleteWorkspace(id)
      set((state) => {
        const remaining = state.workspaces.filter(w => w.id !== id)
        return {
          workspaces: remaining,
          activeWorkspaceId: state.activeWorkspaceId === id ? (remaining[0]?.id || 'default') : state.activeWorkspaceId
        }
      })
    } catch (e) { 
      console.error(e) 
    }
  },
  
  updateWorkspace: async (id, data) => {
    try {
      await workspacesService.updateWorkspace(id, data)
      set((state) => ({
        workspaces: state.workspaces.map(w => w.id === id ? { ...w, ...data } : w)
      }))
    } catch (e) { 
      console.error(e) 
    }
  }
}),
{
    name: 'workspace-storage', // name of item in the storage (must be unique)
    partialize: (state) => ({ activeWorkspaceId: state.activeWorkspaceId }),
  }
))
